import {
  GET_SPECIALTIES_REQUEST,
  GET_SPECIALTIES_RESPONSE,
  ADD_SPECIALTY_REQUEST,
  EDIT_SPECIALTY_REQUEST,
  GET_SPECIALTY_DETAILS_REQUEST,
  GET_SPECIALTY_DETAILS_RESPONSE,
  DELETE_SPECIALTY_REQUEST,
} from "./types";

// list
export const getSpecialtiesRequest = (payload) => ({
  type: GET_SPECIALTIES_REQUEST,
  payload,
});

export const getSpecialtiesResponse = (payload) => ({
  type: GET_SPECIALTIES_RESPONSE,
  payload,
});

// add
export const addSpecialtyRequest = (payload, onSucess) => ({
  type: ADD_SPECIALTY_REQUEST,
  payload,
  onSucess
});

// edit
export const editSpecialtyRequest = (payload) => ({
  type: EDIT_SPECIALTY_REQUEST,
  payload,
});

// get by id (view)
export const getSpecialtyDetailsRequest = (payload) => ({
  type: GET_SPECIALTY_DETAILS_REQUEST,
  payload,
});

export const getSpecialtyDetailsResponse = (payload) => ({
  type: GET_SPECIALTY_DETAILS_RESPONSE,
  payload,
});

export const deleteSpecialtyRequest = (payload) => ({
  type: DELETE_SPECIALTY_REQUEST,
  payload,
});
